// src/hooks/useQrCodeDownload.js
import { useState } from "react";
import QRCodeStyling from "qr-code-styling";
import generateQrCodeOptions from "../utils/generateQrCodeOptions";

const useQrCodeDownload = (qrCode, data, type, options, appSiteUrl) => {
    const [isResolutionModalOpen, setIsResolutionModalOpen] = useState(false);
    const [downloadExtension, setDownloadExtension] = useState(null);

    const handleDownload = (extension) => {
        setDownloadExtension(extension);
        setIsResolutionModalOpen(true);
    };

    const handleResolutionDownload = (resolution) => {
        if (!qrCode) return;

        const qrCodeDownload = new QRCodeStyling({
            width: resolution,
            height: resolution,
            ...generateQrCodeOptions(data, type, options, appSiteUrl)
        });

        qrCodeDownload.download({ extension: downloadExtension, name: 'qrcbr' });
        setIsResolutionModalOpen(false);
    };

    return {
        isResolutionModalOpen,
        handleDownload,
        handleResolutionDownload,
        setIsResolutionModalOpen,
        downloadExtension
    };
};

export default useQrCodeDownload;